import React from "react";
import Pagination from "@mui/material/Pagination";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import PropTypes from "prop-types";

const theme = createTheme({
  components: {
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          margin: 0,
          "&.Mui-selected": {
            color: "white",
            backgroundColor: "#6C36B0",
            borderRadius: "0px",
            border: "none",
            zIndex: 1
          },
          "&.Mui-disabled": {
            opacity: 1,
            borderRight: "1px solid #D9D9D9",
            minWidth: "43px"
          },
          "&.Mui-selected:hover": {
            backgroundColor: "#6C36B0"
          },
          "&.MuiPaginationItem-ellipsis": {
            padding: "8px 10px"
          },
          border: "1px solid #D9D9D9",
          borderRadius: "0px",
          marginRight: "-1px"
        },
        icon: {
          color: "#6C36B0"
        }
      }
    }
  }
});
const CustomPagination = ({
  totalItems,
  itemsPerPage,
  currentPage,
  handleChangePage
}) => {
  return (
    <div className="mt-6 flex justify-center md:justify-end">
      <ThemeProvider theme={theme}>
        <Pagination
          count={Math.ceil(totalItems / itemsPerPage)}
          page={currentPage}
          onChange={handleChangePage}
          shape="rounded"
          size="large"
          sx={{ "& .MuiPaginationItem-root": { margin: 0 } }}
        />
      </ThemeProvider>
    </div>
  );
};

CustomPagination.propTypes = {
  totalItems: PropTypes.number.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  handleChangePage: PropTypes.func.isRequired
};

export default CustomPagination;
